import {createSlice, PayloadAction} from "@reduxjs/toolkit";

type Operation = "save" | "publish";
type Errors = Record<string, Partial<Record<Operation, string>>>;
const slice = createSlice({
    name: "pageOperationErrors",
    initialState: {} as Errors,
    reducers: {
        setPageOperationError(state, {payload}: PayloadAction<{pageId: number; operation: Operation; message: string | null}>) {
            const key = String(payload.pageId);
            if (payload.message === null) {
                if (state[key]) delete state[key][payload.operation];
            } else {
                state[key] ??= {};
                state[key][payload.operation] = payload.message;
            }
        },
        dismissPageOperationErrors(state, {payload}: PayloadAction<number>) {
            delete state[String(payload)];
        },
    },
});
export const {setPageOperationError, dismissPageOperationErrors} = slice.actions;
export default slice.reducer;
